import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  FlashcardInteractionReveresedSchema,
  FlashcardInteractionReviewCardsSchema,
  FlashcardInteractionReviewingSchema,
  FlashcardInteractionShuffleSchema,
  FlashcardInteractionWipeReviewSchema,
  OverallFlashcardReduxSchema,
} from "@tsTypes/flashcard-redux-schema";
import { RootState } from "../../app/store";
import { createMissingFlashcardMeta } from "./FlashcardsHelpers";

const initialState: OverallFlashcardReduxSchema = {};

export const subjectFlashcardsSlice = createSlice({
  name: "subjectFlashcards",
  initialState,
  reducers: {
    deckReverseAction: (
      state,
      action: PayloadAction<FlashcardInteractionReveresedSchema>
    ) => {
      const { subjectDocumentId, deckDocumentId } = action.payload;
      createMissingFlashcardMeta(state, subjectDocumentId, deckDocumentId);
      state[subjectDocumentId]![deckDocumentId]!.reversed =
        !state[subjectDocumentId]![deckDocumentId]!.reversed;
    },
    deckShuffleAction: (
      state,
      action: PayloadAction<FlashcardInteractionShuffleSchema>
    ) => {
      const { subjectDocumentId, deckDocumentId } = action.payload;
      createMissingFlashcardMeta(state, subjectDocumentId, deckDocumentId);
      state[subjectDocumentId]![deckDocumentId]!.shuffled =
        !state[subjectDocumentId]![deckDocumentId]!.shuffled;
    },
    deckReviewingAction: (
      state,
      action: PayloadAction<FlashcardInteractionReviewingSchema>
    ) => {
      const { subjectDocumentId, deckDocumentId, setReviewing } =
        action.payload;
      createMissingFlashcardMeta(state, subjectDocumentId, deckDocumentId);
      state[subjectDocumentId]![deckDocumentId]!.reviewing = setReviewing;
    },
    deckReviewCardsAction: (
      state,
      action: PayloadAction<FlashcardInteractionReviewCardsSchema>
    ) => {
      const { subjectDocumentId, deckDocumentId, cardDocumentId } =
        action.payload;
      createMissingFlashcardMeta(state, subjectDocumentId, deckDocumentId);
      // if adding card to review
      if (
        !state[subjectDocumentId]![deckDocumentId]!.reviewCards.includes(
          cardDocumentId
        )
      ) {
        state[subjectDocumentId]![deckDocumentId]!.reviewCards.push(
          cardDocumentId
        );
      }
      // if removing card from review
      else {
        state[subjectDocumentId]![deckDocumentId]!.reviewCards = state[
          subjectDocumentId
        ]![deckDocumentId]!.reviewCards.filter((ids) => ids !== cardDocumentId);
      }
    },
    deckWipeReviewCardsAction: (
      state,
      action: PayloadAction<FlashcardInteractionWipeReviewSchema>
    ) => {
      const { subjectDocumentId, deckDocumentId } = action.payload;
      createMissingFlashcardMeta(state, subjectDocumentId, deckDocumentId);
      state[subjectDocumentId]![deckDocumentId]!.reviewCards = [];
    },
  },
});

export const {
  deckReverseAction,
  deckShuffleAction,
  deckReviewCardsAction,
  deckReviewingAction,
  deckWipeReviewCardsAction,
} = subjectFlashcardsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectDeckById = (
  state: RootState,
  subjectDocumentId: string,
  deckDocumentId: string
) => state.subjectFlashcards[subjectDocumentId]?.[deckDocumentId];

export default subjectFlashcardsSlice.reducer;
